export const MUTATION = {
  SET_OFFLINE: 'setOffline',
  SET_LOADING: 'setLoading',
  SET_SERVICE_WORKER_STATUS: 'setServiceWorkerStatus',
};
